package kz.dentalcrm.app.screens.positions.list.mvi

import androidx.compose.runtime.Immutable
import kotlinx.collections.immutable.PersistentList
import kotlinx.collections.immutable.persistentListOf
import kz.dentalcrm.app.core.base.ViewState
import kz.dentalcrm.app.data.network.response_model.positions.Position

@Immutable
data class PositionsViewState(
    val positions: PersistentList<Position> = persistentListOf(),
    val screenState: ScreenState = ScreenState.Idle,
    val search: String = ""
) : ViewState {
    sealed interface ScreenState {
        data object Idle : ScreenState
        data object Loading : ScreenState
        data class Error(val text: String) : ScreenState
    }
}
